import overArg from "./_overArg.js";
var nativeKeys = overArg(Object.keys, Object);
export default nativeKeys;
